<template>
  <div class="home-page page-1">
    <div class="home-header">
      <div class="header-logo"><img :src="mb_getLogoById(29)" /></div>
      <div class="home-header-right">
        <template v-if="['themeKYMN'].includes(THEME)">
          <div v-if="activeConfiguration['68']" class="header-right-item d-flex align-items-center"
            @click="$router.push('service')">
            <img src="/images/themeKYMN/home/top_kefu.png" /><span v-text="$t('在线客服')"></span>
          </div>
          <div class="header-right-item d-flex align-items-center" @click="showRight = true">
            <img src="/images/themeKYMN/home/top_setting.png" />
          </div>
        </template>
        <template v-else>
          <div v-if="activeConfiguration['68']" class="header-item" @click="$router.push('service')"><svg-icon
              iconUrl="icon-chat" iconClass="chat" />
          </div>
          <div class="header-item" @click="showRight = true"><svg-icon iconClass="point3" /></div>
        </template>
      </div>
    </div>
    <div class="home-header-zan"></div>
    <div class="page-main page-margin-top-0 page-main-pd-0">
      <div class="banner-wapper">
        <Banner />
      </div>
      <div class="notice-wapper">
        <Notice />
        <div class="userinfo d-flex justify-content-between">
          <!--已登录-->
          <template v-if="isLogined">
            <template v-if="['themeKYMN'].includes(THEME)">
              <div class="userinfo-left fz-13">
                <p class="d-flex align-items-center">
                  <span class="fz-14 text-title text-ellipsis" v-text="userInfo.cust_name"></span>
                  <span class="current-vip" style="margin-left:5px;" @click="$router.push('/vip')"
                    v-text="userInfo.cust_level || 0"></span>
                </p>
                <div class="amount" @click.stop="goPage('/conversionamount')">
                  <span v-text="currencyMoney(blance / 1000)"></span>
                  <svg-icon iconClass="home-reflash" :class="{ blanceActive }" @click.stop="transitionAllYe"></svg-icon>
                </div>
              </div>
            </template>
            <div v-else class="userinfo-left fz-13">
              <p class="d-flex align-items-center">
                <span class="fz-14 text-title text-ellipsis" v-text="userInfo.cust_name"></span>
                <span class="current-vip" style="margin-left:5px;" @click="$router.push('/vip')"
                  v-text="`VIP${userInfo.cust_level || 0}`"></span>
              </p>
              <div class="amount" @click.stop="goPage('/conversionamount')">
                <span v-text="currencyMoney(blance / 1000)"></span>
                <svg-icon iconClass="home-reflash" :class="{ blanceActive }" @click.stop="transitionAllYe"></svg-icon>
              </div>
            </div>
          </template>
          <!--未登录-->
          <template v-else>
            <div class="userinfo-left fz-13 logins-wrap">
              <div class="home-btn-login" @click.stop="$router.push('/login')" v-text="$t('登录')"></div>
              <div class="home-btn-login register" @click.stop="$router.push('/register')" v-text="$t('注册')"></div>
            </div>
          </template>
          <div class="userinfo-right d-flex justify-content-end">
            <template v-if="['themeKYMN'].includes(THEME)">
              <div class="item-col" @click.stop="goPage('/message')">
                <div class="item-img">
                  <img v-if="unRead" :src="`/images/${THEME}/email.png`" />
                  <img v-else :src="`/images/${THEME}/email-normal.png`" />
                </div>
                <div class="item-txt text-ellipsis" v-text="$t('站内信')"></div>
              </div>
              <div class="item-col" @click.stop="goPage('/recharge')">
                <div class="item-img"><img :src="`/images/${THEME}/home/deposit.png`" /></div>
                <div class="item-txt text-ellipsis" v-text="$t('存款')"></div>
              </div>
              <div class="item-col" v-if="activeConfiguration['62']" @click.stop="goPage('/withdrawways')">
                <div class="item-img"><img :src="`/images/${THEME}/home/withdraw2.png`" /></div>
                <div class="item-txt text-ellipsis" v-text="$t('提现')"></div>
              </div>
              <div class="item-col" @click.stop="goPage('/conversionamount')">
                <div class="item-img"><img :src="`/images/${THEME}/home/more.png`" /></div>
                <div class="item-txt text-ellipsis" v-text="$t('更多')"></div>
              </div>
            </template>
            <template v-else>
              <div class="item-col" @click.stop="goPage('/message')">
                <div class="item-img">
                  <img v-if="unRead" :src="`/images/${THEME}/email.png`" />
                  <img v-else :src="`/images/${THEME}/email-normal.png`" />
                </div>
                <div class="item-txt text-ellipsis" v-text="$t('站内信')"></div>
              </div>
              <div class="item-col" @click.stop="goPage('/recharge')">
                <div class="item-img"><img :src="`/images/${THEME}/home/recharge.png`" /></div>
                <div class="item-txt text-ellipsis" v-text="$t('充值')"></div>
              </div>
              <div class="item-col" v-if="activeConfiguration['62']" @click.stop="goPage('/withdrawways')">
                <div class="item-img"><img :src="`/images/${THEME}/home/withdraw.png`" /></div>
                <div class="item-txt text-ellipsis" v-text="$t('提现')"></div>
              </div>
              <!-- <div class="item-col" @click.stop="goPage('/conversionamount')">
              <div class="item-img"><img :src="`/images/${THEME}/mine/quota_conversion.png`" /></div>
              <div class="item-txt text-ellipsis" v-text="$t('额度转换')"></div>
            </div> -->
              <div class="item-col" @click.stop="goPage('/mine')">
                <div class="item-img"><img :src="`/images/${THEME}/home/vip.png`" /></div>
                <div class="item-txt text-ellipsis" v-text="$t('更多')"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="home-main-div">
        <div class="home-nav-fast">
          <div class="fast-item" @click="$router.push('/service')">
            <img :src="`/images/${THEME}/home/home-nave-customer.png`" />
            <span v-text="$t('在线客服')"></span>
          </div>
          <div v-if="activeConfiguration['17']" class="fast-item active" @click="$router.push('/chatroomselect')">
            <img :src="`/images/${THEME}/home/home-nave-chat.png`" />
            <span v-text="$t('聊天室')"></span>
          </div>
          <div v-if="activeConfiguration['34']" class="fast-item" @click="$router.push('/promotemoney')">
            <img :src="`/images/${THEME}/home/home-nave-share.png`" />
            <span v-text="$t('分享好友')"></span>
          </div>
        </div>
        <template v-if="['themeKYMN'].includes(THEME)">
          <div class="home-games-wrap" :class="[{ 'fixed-tab': !isgameContainerBeforeVisible }]">
            <div class="home-game-tab" ref="homeTabs">
              <div class="tab-row-name d-flex align-items-center">
                <template v-for="item in gameAllData" :key="item.key">
                  <div class="game-row-menus-item tab-item d-flex align-items-center"
                    :class="{ 'active': active === item.id }" :title="item.title" :name="item.id"
                    @click="changeTab(item.id)">
                    <img :src="`/images/${THEME}/game-tab-${item.id}.png`" />
                    <div class="game-type">
                      {{item.title ==='PC房间'&&['6-2'].includes(CIDTID)? 'PC28' :$t(item.title) }}
                    </div>
                  </div>
                </template>
              </div>
              <div class="van-tabs__content" ref="tabs_content">
                <div v-for="item in gameAllData" :title="item.title" :name="item.id" :key="item.key"
                  class="van-tab__panel">
                  <div class="game-type-title d-flex align-items-center justify-content-between">
                    <span class="fz-16">
                      {{item.title ==='PC房间'&&['6-2'].includes(CIDTID)? 'PC28' :$t(item.title) }}
                    </span>
                    <span class="game-type-more" @click.stop="$router.push(`/game?key=${item.key}`)"
                      v-text="$t('查看更多')"></span>
                  </div>
                  <div class="block-warp">
                    <GameListRow :key="item.key" :gameData="item.childrens" :gametype="item.key"
                      :gameModeType="['lottery', 'block'].includes(item.key) ? 0 : 1"
                      :rownum="['sports', 'live'].includes(item.key) ? 2 : (['lottery', 'block'].includes(item.key) ? 3 : 4)"
                      :firstBig="['sports'].includes(item.key) ? true : false" :lotteryLoad="lotteryLoad"
                      :isHome="['sports','lottery'].includes(item.key)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="home-games-wrap" :class="[{ 'fixed-tab': !isgameContainerBeforeVisible }]">
            <div class="home-game-tab" ref="homeTabs">
              <div class="tab-name">
                <template v-for="item in gameAllData" :key="item.key">
                  <div class="game-menus-item tab-item" :class="{ 'active': active === item.id }" :title="item.title"
                    :name="item.id" @click="changeTab(item.id)">
                    <img :src="`/images/${THEME}/game-tab-${item.id}.png`" />
                    <div class="game-type">
                      {{item.title ==='PC房间'&&['6-2'].includes(CIDTID)? 'PC28' :$t(item.title) }}
                    </div>
                  </div>
                </template>
              </div>
              <div class="set-base-active position-absolute" style="width: 100%;top:0;left:0;height: 100px;z-index:-1">
              </div>
              <div class="van-tabs__content" ref="tabs_content">
                <template v-for="item in gameAllData" :key="item.key">
                  <div :title="item.title" :name="item.id" class="van-tab__panel">
                    <div class="game-type-title">
                      {{item.title ==='PC房间'&&['6-2'].includes(CIDTID)? 'PC28' :$t(item.title) }}
                    </div>
                    <div class="block-warp">
                      <GameListRow :key="item.key" :gameData="item.childrens" :gametype="item.key"
                        :gameModeType="['lottery', 'block'].includes(item.key) ? 0 : 1"
                        :rownum="['sports', 'live'].includes(item.key) ? 2 : 3"
                        :firstBig="['sports'].includes(item.key) ? true : false" :isHome="['sports'].includes(item.key)"
                        :lotteryLoad="lotteryLoad" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="home-footer-main">
        <div class="footer-row d-flex">
          <span @click.stop="$router.push('/aboutus')" v-text="$t('关于我们')"></span>
          <span @click.stop="$router.push('/helpcenter')" v-text="$t('帮助中心')"></span>
          <span @click.stop="$router.push('/aboutus')" v-text="$t('免责声明')"></span>
        </div>
        <van-divider :style="{ borderColor: '#000' }">{{ $t('我是有底线的') }}</van-divider>
      </div>
    </div>
    <van-popup v-model:show="showRight" class="side-menu-box" teleport="#app-container" position="right">
      <SideMenu v-model:showRight="showRight"></SideMenu>
    </van-popup>

    <ActivitySelector />
  </div>
</template>

<script lang="ts" src="./home.ts"></script>

<style lang="scss" scoped>
@import "./home.scss";
</style>